import { gql } from '@apollo/client';
import { Order, Prescription, User } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const currentOrderWithPrescriptions = () => gql`
  query currentOrderWithPrescriptions($params: CurrentOrderParams) {
    currentOrder(params: $params) {
      id
      orderDetails {
        id
        quantity
        price
        product {
          id
          name
          imagesUrl
          unit
          format
          concentration
          laboratory
          prescriptionType
          availability {
            stock
            statusWithoutStock
            status
          }
        }
        status
        prescription {
          id
        }
      }
    }
    pendingPrescriptions {
      id
      uuid
      url
    }
    currentUserInfo {
      id
      createdAt
    }
  }
`;

export type CurrentOrderWithPrescriptionsQueryResponse = {
  currentOrder?: Order;
  pendingPrescriptions?: Prescription[];
  currentUserInfo: Pick<User, 'id' | 'createdAt'>;
};

export type CurrentOrderWithPrescriptionsQueryParams = ResolverParams<{
  orderUuid?: string;
}>;
